import React from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import NavigatorWrapper from '../navigator/navigatorWrapper'
import Dialog from '../pages/dialog/dialog'

const pudoYellow = {
    light: '#ffe74c',
    main: '#f7b500',
    dark: '#bf8600',
    contrastText: '#000000',
}
const pudoGrey = {
    light: '#e2e2db',
    main: '#b0b0a9',
    dark: '#81817a',
    contrastText: '#000000',
}

const onlineTheme = createMuiTheme({
    palette: {
        primary: pudoYellow,
        secondary: pudoGrey,
    },
    status: {
        danger: pudoYellow,
    },
    typography: {
        fontFamily: ['neutra'].join(','),
        fontSize: 16,
        useNextVariants: true,
    },
})

class Theme extends React.Component {
    render() {
        return (
            <MuiThemeProvider theme={onlineTheme}>
                <Dialog />
                <NavigatorWrapper />
            </MuiThemeProvider>
        )
    }
}

export default Theme
